import { SVGProps } from "react";

export default function EditIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#4B5563", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.0514 2.99999L4.20976 10.2417C3.95142 10.5167 3.70142 11.0583 3.65142 11.4333L3.34309 14.1333C3.23476 15.1083 3.93476 15.775 4.90142 15.6083L7.58476 15.15C7.95976 15.0833 8.48476 14.8083 8.74309 14.525L15.5848 7.28332C16.7681 6.03332 17.3014 4.60832 15.4598 2.86665C13.6264 1.14165 12.2348 1.74999 11.0514 2.99999Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.90625 4.20837C10.2646 6.50837 12.1312 8.26671 14.4479 8.50004"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 18.3333H17.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}